<template lang="pug">
  .b-scroller(@click="scroll")
    Icon._icon(name="arr-scroll" pointer :class="{ up }")
</template>

<script>
export default {
  name: 'PageScroller',
  data() {
    return { up: false };
  },
  methods: {
    scroll() {
      const top = this.up ? 0 : document.documentElement.scrollHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    },
    onScroll() {
      this.up = window.scrollY > (document.documentElement.scrollHeight - document.documentElement.clientHeight) / 2;
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style scoped lang="scss">
  .scroller {
    width: 48px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    position: fixed;
    bottom: 100px;
    left: calc(10vw - 128px);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1000;

    &__icon.up {
      transform: rotate(180deg);
    }

    @media (max-width: 1700px) {
      left: 96px;
    }

    @media (max-width: 1700px) {
      left: 48px;
    }

    @media (max-width: 576px) {
      left: 12px;
    }
  }
</style>
